"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _MultiselectDropdownClient = require("./MultiselectDropdownClient");
var _TextInput = _interopRequireDefault(require("../../TextInput/TextInput"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/search/24.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.custom-filter {\n  display: flex;\n  gap: 16px; }\n  .custom-filter .search {\n    min-width: 244px;\n    position: relative; }\n    .custom-filter .search svg {\n      position: absolute;\n      right: 8px;\n      top: 32px;\n      cursor: pointer; }\n    .custom-filter .search label {\n      opacity: 0; }\n    .custom-filter .search input {\n      padding-right: 42px; }\n\n@media (max-width: 66rem) {\n  .custom-filter {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    row-gap: 0px; } }\n\n@media (max-width: 42rem) {\n  .custom-filter {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0px; } }\n";
  const fileName = "Filter_Filter";
  const element = document.querySelector("style[data-sass-component='Filter_Filter']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Filter = _ref => {
  let {
    translate,
    filters,
    onChange,
    activeFilters
  } = _ref;
  const [search, setSearch] = (0, _react.useState)('');
  const [selectedValues, setSelectedValues] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    handleChange();
  }, [selectedValues]);
  const handleChange = () => {
    onChange({
      ...selectedValues,
      search: search
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-filter"
  }, filters.map(filter => /*#__PURE__*/_react.default.createElement(_MultiselectDropdownClient.MultiselectDropdownClient, {
    key: filter.label,
    id: filter.label,
    label: translate('cms.custom-filter.' + filter.label),
    items: filter.items.map(el => ({
      id: el.id,
      label: el.title
    })),
    values: selectedValues[filter.label],
    setValues: values => {
      setSelectedValues({
        ...selectedValues,
        [filter.label]: values
      });
    },
    activeItems: activeFilters ? activeFilters.find(el => el.label === filter.label)?.items || [] : filter.items.map(el => ({
      id: el.id,
      label: el.title
    }))
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "search"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    defaultValue: '',
    id: 'name',
    label: 'name',
    name: 'name',
    onChange: event => {
      setSearch(event.target.value);
    },
    placeholder: translate('cms.custom-filter.search'),
    onKeyDown: e => {
      e.key === 'Enter' && handleChange();
    },
    onBlur: event => {
      handleChange();
    }
  }), /*#__PURE__*/_react.default.createElement(_.default, {
    onClick: () => onChange({
      ...selectedValues,
      search: search
    })
  })));
};
var _default = exports.default = Filter;